module.exports = __webpack_public_path__ + "img/own.f748a324.png";